import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const SUB_ACCOUNT_TYPE = 'SUB_ACCOUNT';

interface InternalSubAccountDto {
  account_id: number;
  account_number: string;
  routing_transit_number: string;
}

const QUERY_KEY = 'useGetInternalSubAccountNumberQueryKey';

export const useGetInternalSubAccountNumberQuery = (accountNumber?: string | number) => {
  const { isLoading, isSuccess, isError, data, error } = useQuery(
    [QUERY_KEY, accountNumber],
    accountNumber
      ? () =>
          // TODO: this DTO type is missing
          api.get<InternalSubAccountDto>(API_URL.ACCOUNTS_INTERNAL_NUMBER_BY_ACCOUNT_ID(`${accountNumber}`), {
            params: {
              account_type: SUB_ACCOUNT_TYPE,
            },
          })
      : () => null
  );

  return {
    accountNumber: data?.data?.account_number,
    routingNumber: data?.data?.routing_transit_number,
    error,
    isError,
    isLoading,
    isSuccess,
  };
};
